var f = (c, i, r) => new Promise((t, m) => {
  var a = (e) => {
    try {
      l(r.next(e));
    } catch (s) {
      m(s);
    }
  }, n = (e) => {
    try {
      l(r.throw(e));
    } catch (s) {
      m(s);
    }
  }, l = (e) => e.done ? t(e.value) : Promise.resolve(e.value).then(a, n);
  l((r = r.apply(c, i)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import _ from "./userSelectedDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as y } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as h, useTemplateRef as v, withDirectives as S, openBlock as g, createBlock as w, withCtx as u, createVNode as d } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as D } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const U = /* @__PURE__ */ h({
  name: "UserSelectedDialogEntry",
  __name: "index.ce",
  setup(c, { expose: i }) {
    const r = v("userSelectedDialogRefs");
    let t = null;
    const m = D(), a = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, n = (...s) => f(this, [...s], function* (e = {}) {
      var p;
      return (p = r.value) == null || p.open(e), new Promise((C) => {
        t = C;
      });
    }), l = (e) => {
      t && (t(e), t = null);
    };
    return i({ open: n }), (e, s) => S((g(), w(o(N), {
      locale: o(R),
      "date-locale": o(x),
      "theme-overrides": a,
      "style-mount-target": o(m)
    }, {
      default: u(() => [
        d(o(P), { to: o(m) }, {
          default: u(() => [
            d(_, {
              ref_key: "userSelectedDialogRefs",
              ref: r,
              onSubmit: l
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [o(y), o(m)]
    ]);
  }
});
export {
  U as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/userSelectedDialog/index.ce.vue2.js
// module id = 1338
// module chunks = 67